module.exports = __webpack_public_path__ + "img/teepee--full.6a84e519.jpg";